import { createContext } from 'react';

export const SocialExportContext = createContext<{
  mediaUrl: string;
}>({
  mediaUrl: '',
});
